import {AfterViewInit, Directive, ElementRef, OnDestroy} from '@angular/core';

/**
 * Máscara de horário (sobrescrita) para o input interno de um p-calendar
 * timeOnly. O campo mantém o formato fixo HH:mm e cada dígito digitado
 * substitui a posição sob o cursor, pulando o ":" automaticamente — como em
 * campos de hora reais. O valor montado é sempre válido (HH<=23, mm<=59),
 * então o p-calendar faz o parse normal para Date e dispara o ngModelChange,
 * preservando os limites e validações já existentes.
 */
@Directive({
	selector: '[timeMask]'
})
export class TimeMaskDirective implements AfterViewInit, OnDestroy {

	private input?: HTMLInputElement;
	private readonly onKeydown = (event: KeyboardEvent) => this.overwrite(event);

	constructor(private host: ElementRef<HTMLElement>) {}

	ngAfterViewInit(): void {
		this.input = this.host.nativeElement.querySelector('input') ?? undefined;
		this.input?.addEventListener('keydown', this.onKeydown);
	}

	ngOnDestroy(): void {
		this.input?.removeEventListener('keydown', this.onKeydown);
	}

	private overwrite(event: KeyboardEvent): void {
		// deixa passar atalhos e teclas de navegação/edição (Tab, setas, Backspace…)
		if (event.ctrlKey || event.metaKey || event.altKey) return;
		if (event.key.length !== 1 || event.key < '0' || event.key > '9') return;

		const input = this.input!;
		event.preventDefault();

		let pos = input.selectionStart ?? 0;
		if (pos === 2) pos = 3;        // pula o ":"
		if (pos > 4) return;           // HH:mm já completo

		const slots = (input.value.replace(/\D/g, '') || '0000').padEnd(4, '0').slice(0, 4).split('');
		slots[pos < 2 ? pos : pos - 1] = event.key;

		const hours = Math.min(23, Number(slots[0] + slots[1]));
		const minutes = Math.min(59, Number(slots[2] + slots[3]));
		input.value = `${this.pad(hours)}:${this.pad(minutes)}`;

		const next = pos + 1 === 2 ? 3 : pos + 1;
		input.setSelectionRange(next, next);
		input.dispatchEvent(new Event('input', {bubbles: true}));
	}

	private pad(value: number): string {
		return String(value).padStart(2, '0');
	}
}
